import { omit } from 'lodash';
import { nanoid } from 'nanoid';
import type { ReactNode } from 'react';
import NotifyContainer from './NotifyContainer';

interface Message {
  title?: string;
  message: ReactNode;
  duration?: number;
}

interface MessageInternal extends Message {
  type: 'info' | 'warning' | 'error';
}

let list: { [key: string]: MessageInternal } = {};
let listeners: any[] = [];

const store = {
  info(message: Message): string {
    const id = nanoid();
    list = { ...list, [id]: { ...message, type: 'info' } };
    emitChange();
    return id;
  },

  warning(message: Message): string {
    const id = nanoid();
    list = { ...list, [id]: { ...message, type: 'warning' } };
    emitChange();
    return id;
  },

  error(message: Message): string {
    const id = nanoid();
    list = { ...list, [id]: { ...message, type: 'error' } };
    emitChange();
    return id;
  },

  subscribe(listener: any) {
    listeners = [...listeners, listener];
    return () => {
      listeners = listeners.filter((l) => l !== listener);
    };
  },

  // Used by NotifyContainer when Radix closes a toast itself; intentionally
  // does not emit so the exit animation isn't cut short by an unmount.
  delete(messageId: string) {
    list = omit(list, messageId);
  },

  /**
   * Programmatically remove a toast (emits, so it unmounts immediately).
   * Needed when a toast's action has been taken — e.g. its link clicked —
   * because Radix pauses auto-dismiss timers while focus stays inside the
   * toast viewport, which can otherwise leave the toast up forever.
   */
  dismiss(messageId: string) {
    list = omit(list, messageId);
    emitChange();
  },

  getSnapshot() {
    return list;
  },
};

function emitChange() {
  for (const listener of listeners) {
    listener();
  }
}

export default store;

export { store, store as Notify, NotifyContainer };
